import { render, staticRenderFns } from "./CoursewareBeforeAfterBlock.vue?vue&type=template&id=f4053856&scoped=true&"
import script from "./CoursewareBeforeAfterBlock.vue?vue&type=script&lang=js&"
export * from "./CoursewareBeforeAfterBlock.vue?vue&type=script&lang=js&"
import style0 from "./CoursewareBeforeAfterBlock.vue?vue&type=style&index=0&id=f4053856&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4053856",
  null
  
)

export default component.exports